var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6424B55E90779Eaa597944F6TwitchLogoDarkstudioXWebflowTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 52,
    viewBox: "0 0 154 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.519 9.56592H139.802V0.161621H125.052L118.269 9.56592H106.215L102.185 13.5963V9.56592H92.7806V0.161621H63.2242V9.56592H21.6438L14.8592 0.161621H0.0810547V32.4049L18.8897 51.2135H37.6982V45.8396L43.0721 51.2135H79.3459V45.8396L84.7197 51.2135H102.185V45.8396L107.559 51.2135H141.146L153.237 39.1223V16.2833L146.519 9.56592ZM22.9201 23.0006H13.5158V25.6876H22.9201V36.4353H8.14188L2.768 31.0615V2.84856H13.5158V12.2529H22.9201V23.0006ZM63.2242 36.4353H30.9809L25.607 31.0615V12.2529H36.3548V25.6876H39.0417V12.2529H49.7895V25.6876H52.4764V12.2529H63.2242V36.4353ZM76.6589 36.4353H65.9111V12.2529H76.6589V36.4353ZM76.6589 9.56592H65.9111V2.84856H76.6589V9.56592ZM99.4979 23.0006H90.0936V25.6876H99.4979V36.4353H84.7197L79.3459 31.0615V2.84856H90.0936V12.2529H99.4979V23.0006ZM123.68 23.0006H112.933V25.6876H123.68V36.4353H107.559L102.185 31.0615V17.6267L107.559 12.2529H123.68V23.0006ZM150.55 36.4353H139.802V23.0006H137.115V36.4353H126.367V2.84856H137.115V12.2529H145.176L150.55 17.6267V36.4353Z",
    fill: "#C0C0C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6424B55E90779Eaa597944F6TwitchLogoDarkstudioXWebflowTemplate);
export default __webpack_public_path__ + "static/media/6424b55e90779eaa597944f6_twitch-logo-darkstudio-x-webflow-template.aec431132fad9879555a269525f51299.svg";
export { ForwardRef as ReactComponent };